var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _g, _path59, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRubixConnect(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 432,
    height: 762,
    viewBox: "0 0 432 762",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M115.19 206.48L299.58 312.25L244.03 344.32L59.6299 238.56L115.19 206.48Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M114.94 77.6201L114.66 205.6L299.78 314.18L299.72 185.88L114.94 77.6201Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2803 245.23L119.94 217.14L131.95 224.39L83.3003 252.48",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8398 256.14L137.49 228.05L149.51 235.3L100.85 263.39",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M107.101 266.42L155.761 238.33L167.771 245.58L119.111 273.67",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M125.63 277.339L174.28 249.239L186.3 256.499L137.64 284.589",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M144.59 287.319L193.24 259.229L205.25 266.479L156.6 294.569",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M162.141 298.23L210.801 270.14L222.811 277.39L174.151 305.48",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M180.4 308.51L229.06 280.42L241.07 287.67L192.42 315.76",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M198.931 319.43L247.591 291.34L259.601 298.59L210.941 326.68",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M218.87 330.43L267.52 302.34L279.54 309.59L230.88 337.68",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M236.42 341.35L285.08 313.26L297.09 320.51L248.44 348.6",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M254.681 351.63L303.341 323.54L315.351 330.79L266.701 358.88",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M273.21 362.539L321.87 334.449L333.88 341.699L285.22 369.789",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M292.17 372.52L340.82 344.43L352.84 351.68L304.18 379.78",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M309.721 383.44L358.381 355.35L370.391 362.6L321.741 390.69",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M284.65 644.38L283.15 623.22C278.54 534.04 278.54 444.69 283.15 355.52L288.5 270.14L290.14 245.11L244.04 217.88V344.31L59.6297 238.56V110.25L12.9497 83.4697L8.02967 158.78C1.41967 259.78 0.739668 361.08 5.97967 462.16L12.9497 596.69L58.9997 623.29V497.17L244.03 603.32V731.63L290.13 758.35L288.66 734.26",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M284.65 644.38L283.15 623.22C278.54 534.04 278.54 444.69 283.15 355.52L288.5 270.14L290.14 245.11L244.04 217.88V344.31L59.6297 238.56V110.25L12.9497 83.4697L8.02967 158.78C1.41967 259.78 0.739668 361.08 5.97967 462.16L12.9497 596.69L58.9997 623.29V497.17L244.03 603.32V731.63L290.13 758.35L288.66 734.26",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M244.03 668.43L114.63 591.79V527.71L244.03 604.57V668.43Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7998 238.41L115.36 206.33V78.7998L59.7998 110.88V238.41Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9502 83.47L151.55 2.5L428.73 164.15L290.13 245.11L244.03 217.89L299.72 185.88L115.54 78.43L59.6302 110.25L12.9502 83.47Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M267.24 286.73L291.66 245.38L430.26 164.42V677.65L291.66 758.61L280.82 570.26L280.72 416.28L284.67 355.52L264.82 358.88",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M288.98 734.35L290.13 758.61L428.73 677.65V164.42L290.13 245.38L289.01 270.05",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M288.98 734.35L290.13 758.61L428.73 677.65V164.42L290.13 245.38L289.01 270.05",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M283.14 355.79L281.56 391.01C279.04 446.28 278.51 500.24 280.52 555.53L284.73 644.6",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M283.14 355.79L281.56 391.01C279.04 446.28 278.51 500.24 280.52 555.53L284.73 644.6",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M287.84 710.15L288.26 719.15",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M286.62 684.42L287.12 694.98",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M285.45 659.64L285.91 669.37",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M284.88 333L284.54 340.51",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M285.97 309.13L285.6 317.2",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M287.38 285.19L286.96 294.48",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M122.9 18.64L400.6 180.85L401.25 693.7L428.73 677.65V164.42L151.55 2.5L122.9 18.64Z",
    fill: "#D7DCE0",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2399 242.16L23.9899 278.67C21.4099 320.6 21.2399 362.65 23.4899 404.6L26.2399 455.95L257.3 590.39L255.17 552.93C252.29 502.13 252.48 451.19 255.74 400.41L257.3 376.17L26.2399 242.16Z",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M114.63 591.73L59.07 623.81L59 495.53L114.63 527.65V591.73Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M114.8 50.8101L146.32 32.6201L177.83 50.6501L146.32 69.0001L114.8 50.8101Z",
    fill: "#B2B2B2",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M288.49 270.41L346.1 238.87V252.49L287.51 285.44L266.77 273.89C264.63 272.7 263.28 270.45 263.24 267.99C263.16 262.68 268.88 259.29 273.5 261.91L288.49 270.41Z",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M286.91 294.54L346.1 263.29V276.91L285.97 309.13L266.48 297.85C264.44 296.67 263.16 294.5 263.13 292.14C263.05 286.86 268.82 283.55 273.34 286.29L286.92 294.54H286.91Z",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M285.4 317.6L346.1 286.73V300.35L284.43 332.79L266.21 321.18C264.32 319.98 263.16 317.9 263.13 315.66C263.05 310.35 268.9 307.08 273.38 309.94L285.4 317.6Z",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M284.48 341.53L346.1 309.95V323.57L283.14 355.79L266.12 344.89C264.28 343.71 263.15 341.69 263.12 339.5C263.04 334.24 268.91 331.06 273.27 334L284.47 341.54L284.48 341.53Z",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M288.409 719.24L350.029 687.66V701.28L288.669 734.52L270.059 722.59C268.219 721.41 267.089 719.39 267.059 717.2C266.979 711.94 272.849 708.76 277.209 711.7L288.409 719.24Z",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M287.23 695.051L348.85 663.471V677.091L287.49 710.331L268.88 698.401C267.04 697.221 265.91 695.201 265.88 693.011C265.8 687.751 271.67 684.571 276.03 687.511L287.23 695.051Z",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M285.919 669.381L347.539 637.801V651.421L286.179 684.661L267.569 672.731C265.729 671.551 264.599 669.531 264.569 667.341C264.489 662.081 270.359 658.901 274.719 661.841L285.919 669.381Z",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M284.65 644.65L346.27 613.07V626.69L284.91 659.93L266.3 648C264.46 646.82 263.33 644.8 263.3 642.61C263.22 637.35 269.09 634.17 273.45 637.11L284.65 644.65Z",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M10.76 111.75L29.34 122.06C31.26 123.13 32.46 125.13 32.5 127.32C32.57 132.06 27.45 135.08 23.31 132.75L9.70996 125.06",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M9.37031 134.86L27.9503 145.17C29.8703 146.24 31.0703 148.24 31.1103 150.43C31.1803 155.17 26.0603 158.19 21.9203 155.86L8.32031 148.17",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M8.07051 157.47L26.6505 167.78C28.5705 168.85 29.7705 170.85 29.8105 173.04C29.8805 177.78 24.7605 180.8 20.6205 178.47L7.02051 170.78",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66035 180.08L25.2404 190.39C27.1604 191.46 28.3604 193.46 28.4004 195.65C28.4704 200.39 23.3503 203.41 19.2104 201.08L5.61035 193.39",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M7.87988 491.24L26.4599 501.55C28.3799 502.62 29.5799 504.62 29.6199 506.81C29.6899 511.55 24.5699 514.57 20.4299 512.24L8.21988 505.33",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99023 514.79L27.5702 525.1C29.4902 526.17 30.6902 528.17 30.7302 530.36C30.8002 535.1 25.6802 538.12 21.5402 535.79L9.76023 529.13",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M9.87012 537.86L28.4501 548.17C30.3701 549.24 31.5701 551.24 31.6101 553.43C31.6801 558.17 26.5601 561.19 22.4201 558.86L10.6401 552.2",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5195 561.33L29.3895 571.25C31.3095 572.32 32.5095 574.32 32.5495 576.51C32.6195 581.25 27.4995 584.27 23.3595 581.94L11.8395 575.43",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M311.22 152.4L330.94 141.02L362.45 159.05L342.57 170.63C335.38 174.82 326.49 174.84 319.28 170.68L311.22 166.03C305.98 163 305.98 155.44 311.22 152.41V152.4Z",
    fill: "#B2B2B2",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M352.08 128.81L313.84 128.65L314.29 155.79C314.29 155.91 314.28 156.02 314.28 156.14C314.28 156.31 314.28 156.49 314.31 156.66C314.85 161.7 323.19 165.7 333.41 165.7C343.63 165.7 352.53 161.42 352.53 156.14L352.09 128.81H352.08Z",
    fill: "#FBB93E",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M332.96 118.61C321.94 118.61 313.01 123.04 313.01 128.49C313.01 133.94 321.94 138.37 332.96 138.37C343.98 138.37 352.91 133.94 352.91 128.49C352.91 123.04 343.98 118.61 332.96 118.61ZM332.96 136.65C323.86 136.65 316.48 132.99 316.48 128.49C316.48 123.99 323.86 120.32 332.96 120.32C342.06 120.32 349.44 123.98 349.44 128.49C349.44 133 342.06 136.65 332.96 136.65Z",
    fill: "black"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M350.16 128.521C350.16 133.011 342.46 136.651 332.96 136.651C323.46 136.651 315.77 133.011 315.77 128.521C315.77 124.031 323.47 120.391 332.96 120.391C342.45 120.391 350.16 124.031 350.16 128.521Z",
    fill: "#FBB93E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_934_1202",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 41,
    y: 271,
    width: 93,
    height: 78
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8701 296.09L41.9401 271.07L133.29 323.81L133.22 348.83L41.8701 296.09Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_934_1202)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_934_1202",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 41,
    y: 271,
    width: 93,
    height: 78
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9401 271.07L133.29 323.81L133.22 348.83L41.8701 296.09L41.9401 271.07Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_934_1202)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.24 297.41L75.36 296.32V300.97C75.35 301.56 75.35 302.15 75.36 302.71C75.37 303.27 75.38 303.81 75.4 304.33C75.41 304.84 75.44 305.34 75.47 305.81C75.49 306.28 75.52 306.72 75.56 307.14C75.56 307.27 75.58 307.39 75.59 307.51L68.52 292.38L66.83 291.4L66.79 305.57L68.67 306.66L68.69 300.77C68.69 300.65 68.69 300.51 68.69 300.34C68.69 300.17 68.68 299.97 68.67 299.71C68.66 299.45 68.64 299.12 68.61 298.7C68.59 298.29 68.55 297.78 68.51 297.18C68.48 296.75 68.45 296.24 68.41 295.67L75.49 310.59L77.21 311.59L77.25 297.42",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9909 303.7L80.1909 302.66L80.1709 309.22C80.1709 310.1 80.3009 310.93 80.5609 311.72C80.8209 312.51 81.1909 313.21 81.6709 313.85C82.1509 314.48 82.7109 314.98 83.3609 315.36C83.8909 315.66 84.3709 315.83 84.8309 315.85C85.2909 315.88 85.6809 315.78 86.0109 315.57C86.1609 315.47 86.2909 315.35 86.4009 315.21V316.9L88.2009 317.94L88.2309 307.32L86.4309 306.28L86.4109 312.68C86.4109 313.05 86.3509 313.37 86.2309 313.63C86.1109 313.89 85.9509 314.07 85.7509 314.18C85.5509 314.29 85.3009 314.33 85.0309 314.3C84.7509 314.26 84.4409 314.15 84.1009 313.96C83.6509 313.7 83.2609 313.36 82.9409 312.93C82.6209 312.5 82.3809 312.01 82.2109 311.46C82.0509 310.91 81.9609 310.33 81.9709 309.7L81.9909 303.71",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.2405 320.29C94.6905 319.97 94.2105 319.54 93.7905 318.98C93.3805 318.42 93.0505 317.8 92.8005 317.12C92.5605 316.43 92.4405 315.72 92.4405 315.03C92.4405 314.34 92.5705 313.79 92.8105 313.39C93.0505 312.98 93.3905 312.74 93.8005 312.67C94.2205 312.61 94.7105 312.73 95.2505 313.04C95.7905 313.35 96.2805 313.79 96.7005 314.34C97.1205 314.9 97.4505 315.52 97.6905 316.2C97.9205 316.88 98.0405 317.55 98.0405 318.26C98.0405 318.97 97.9105 319.52 97.6705 319.93C97.4205 320.33 97.0905 320.57 96.6705 320.65C96.2505 320.73 95.7705 320.61 95.2405 320.3M92.5705 305.45L90.7705 304.41L90.7305 319.33L92.5305 320.37V319.02C92.7405 319.43 93.0005 319.84 93.3005 320.26C93.6205 320.7 93.9805 321.1 94.3605 321.47C94.7505 321.84 95.1405 322.15 95.5405 322.38C96.3405 322.84 97.0705 323.02 97.7105 322.91C98.3505 322.8 98.8605 322.43 99.2205 321.81C99.5805 321.19 99.7705 320.34 99.7805 319.27C99.7905 318.2 99.6005 317.15 99.2305 316.1C98.8605 315.06 98.3505 314.11 97.7205 313.27C97.0805 312.42 96.3505 311.77 95.5305 311.29C95.1505 311.07 94.7905 310.94 94.4205 310.87C94.0505 310.8 93.7205 310.8 93.4205 310.86C93.1105 310.92 92.8605 311.03 92.6605 311.21C92.6205 311.24 92.5905 311.28 92.5605 311.31L92.5805 305.45",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.051 320.01C103.111 319.74 103.191 319.5 103.291 319.31C103.511 318.9 103.841 318.69 104.271 318.66C104.701 318.64 105.231 318.8 105.861 319.17C106.261 319.4 106.621 319.71 106.961 320.1C107.301 320.5 107.571 320.93 107.791 321.41C108.011 321.89 108.141 322.37 108.171 322.83V322.97L103.051 320.01ZM105.871 317.24C105.191 316.85 104.571 316.63 103.991 316.57C103.411 316.51 102.921 316.62 102.501 316.89C102.081 317.16 101.761 317.57 101.521 318.12C101.291 318.68 101.171 319.37 101.171 320.21C101.171 321.26 101.371 322.31 101.781 323.36C102.191 324.4 102.761 325.37 103.491 326.26C104.211 327.14 105.051 327.86 105.991 328.4C106.421 328.65 106.861 328.83 107.311 328.95C107.761 329.06 108.191 329.12 108.581 329.1C108.991 329.1 109.331 329 109.601 328.84L108.701 326.85C108.241 327.04 107.821 327.11 107.431 327.06C107.041 327.01 106.621 326.86 106.171 326.59C105.531 326.22 104.961 325.75 104.481 325.17C103.991 324.59 103.611 323.95 103.351 323.25C103.151 322.72 103.021 322.18 102.981 321.62L109.991 325.66L110.011 324.78C110.021 324.05 109.931 323.3 109.731 322.55C109.531 321.81 109.241 321.1 108.871 320.42C108.491 319.74 108.041 319.13 107.531 318.57C107.021 318.01 106.461 317.56 105.881 317.22",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.951 325.04L117.161 324L117.131 334.63L118.921 335.67L118.951 325.04Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.041 319.53C117.671 319.32 117.381 319.26 117.161 319.38C116.951 319.5 116.841 319.76 116.841 320.15C116.841 320.57 116.941 320.95 117.151 321.3C117.361 321.65 117.651 321.94 118.041 322.16C118.431 322.38 118.701 322.42 118.921 322.3C119.141 322.18 119.241 321.931 119.241 321.541C119.241 321.121 119.141 320.741 118.931 320.391C118.731 320.041 118.411 319.75 118.041 319.53Z",
    fill: "#459AA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.251 338.55C126.661 338.21 126.111 337.76 125.621 337.22C125.121 336.68 124.701 336.08 124.331 335.4C123.961 334.73 123.681 334.02 123.491 333.27C123.301 332.52 123.201 331.79 123.201 331.03C123.201 330.27 123.311 329.64 123.501 329.12C123.701 328.6 123.981 328.22 124.351 327.98C124.721 327.74 125.151 327.63 125.641 327.65C126.141 327.68 126.681 327.87 127.281 328.21C127.881 328.55 128.421 328.99 128.911 329.53C129.411 330.07 129.831 330.68 130.201 331.35C130.561 332.03 130.841 332.74 131.041 333.48C131.241 334.22 131.341 334.97 131.341 335.71C131.341 336.45 131.231 337.08 131.031 337.59C130.821 338.1 130.541 338.49 130.181 338.75C129.811 339 129.391 339.12 128.891 339.08C128.401 339.05 127.851 338.87 127.261 338.53M127.291 326.1C126.431 325.6 125.641 325.33 124.911 325.27C124.181 325.22 123.551 325.37 123.001 325.7C122.461 326.04 122.031 326.57 121.741 327.28C121.441 328 121.291 328.88 121.281 329.93C121.271 330.98 121.431 332.04 121.721 333.09C122.021 334.14 122.431 335.16 122.971 336.13C123.511 337.1 124.141 337.97 124.871 338.75C125.601 339.54 126.391 340.18 127.251 340.68C128.111 341.18 128.901 341.45 129.631 341.5C130.361 341.56 130.991 341.4 131.541 341.06C132.081 340.71 132.501 340.18 132.801 339.47C133.101 338.76 133.251 337.88 133.251 336.84C133.251 335.8 133.111 334.75 132.821 333.7C132.521 332.65 132.101 331.63 131.571 330.66C131.031 329.69 130.401 328.81 129.671 328.02C128.941 327.24 128.151 326.6 127.291 326.1Z",
    fill: "#459AA4"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_934_1202",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 107,
    y: 455,
    width: 137,
    height: 116
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M107.43 491.48L107.53 455.85L243.98 534.63L243.88 570.26L107.43 491.48Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_934_1202)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.769 483.46V478.82L123.969 480.08C124.719 480.51 125.279 481.04 125.649 481.66C126.009 482.27 126.199 482.94 126.189 483.66C126.179 484.38 125.999 484.84 125.619 485.04C125.249 485.25 124.689 485.14 123.949 484.72L121.769 483.46ZM123.979 478.23L119.819 475.83L119.779 489.65L121.749 490.79L121.769 485.26L123.279 486.13L126.039 493.26L128.389 494.62L125.429 487.17C126.379 487.45 127.079 487.36 127.529 486.89C127.989 486.41 128.219 485.73 128.219 484.83C128.219 484.06 128.059 483.27 127.749 482.47C127.429 481.66 126.959 480.89 126.319 480.14C125.679 479.4 124.899 478.76 123.979 478.23Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.38 490L137.41 488.86L137.39 494.96C137.39 495.94 137.17 496.57 136.73 496.84C136.3 497.11 135.71 497.04 134.97 496.61C134.23 496.18 133.65 495.58 133.23 494.82C132.8 494.05 132.59 493.17 132.59 492.19L132.61 486.09L130.66 484.96L130.64 491.39C130.64 492.39 130.81 493.34 131.14 494.23C131.48 495.13 131.95 495.93 132.54 496.63C133.13 497.33 133.8 497.9 134.55 498.33C135.12 498.66 135.65 498.84 136.15 498.87C136.65 498.9 137.06 498.78 137.37 498.51V499.81L139.34 500.95L139.37 490",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.809 503.469C146.309 503.179 145.839 502.759 145.399 502.219C144.949 501.669 144.599 501.039 144.329 500.319C144.059 499.599 143.919 498.869 143.929 498.109C143.939 497.349 144.069 496.769 144.339 496.369C144.609 495.969 144.969 495.759 145.419 495.719C145.859 495.679 146.329 495.809 146.829 496.089C147.329 496.369 147.809 496.799 148.249 497.339C148.699 497.879 149.049 498.499 149.319 499.209C149.589 499.919 149.729 500.649 149.719 501.399C149.709 502.149 149.579 502.749 149.309 503.149C149.039 503.569 148.679 503.789 148.229 503.839C147.789 503.879 147.309 503.759 146.799 503.469M143.959 488.869L141.989 487.729L141.949 502.449L143.919 503.589V501.999C144.259 502.709 144.709 503.389 145.279 504.049C145.849 504.709 146.499 505.259 147.239 505.679C148.079 506.159 148.829 506.359 149.519 506.269C150.199 506.179 150.749 505.819 151.139 505.179C151.529 504.529 151.729 503.659 151.739 502.559C151.749 501.459 151.549 500.369 151.159 499.289C150.769 498.209 150.239 497.239 149.559 496.379C148.879 495.519 148.119 494.849 147.279 494.359C146.559 493.949 145.919 493.739 145.339 493.749C144.749 493.749 144.299 493.929 143.959 494.259L143.979 488.869",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.669 499.409L153.699 498.269L153.669 509.219L155.639 510.359L155.669 499.409ZM154.719 494.489C154.359 494.279 154.059 494.25 153.819 494.39C153.579 494.53 153.449 494.799 153.449 495.209C153.449 495.619 153.569 496.04 153.809 496.45C154.049 496.87 154.349 497.179 154.699 497.379C155.049 497.579 155.349 497.609 155.589 497.469C155.829 497.329 155.959 497.059 155.959 496.649C155.959 496.239 155.839 495.819 155.599 495.409C155.359 494.999 155.059 494.68 154.709 494.48",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.429 505.04L163.369 503.85L161.419 506.44L159.379 501.54L157.139 500.25L160.209 507.6L157.109 511.21L159.169 512.4L161.119 509.8L163.169 514.71L165.399 515.99L162.339 508.67L165.429 505.04Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.889 508.609C175.769 507.959 174.739 507.669 173.799 507.729C172.859 507.799 172.119 508.209 171.559 508.959C171.009 509.709 170.729 510.769 170.729 512.119C170.729 513.469 170.999 514.839 171.539 516.229C172.089 517.619 172.819 518.879 173.749 520.019C174.679 521.169 175.709 522.069 176.839 522.719C178.119 523.459 179.259 523.759 180.259 523.609C181.259 523.469 181.989 522.869 182.439 521.799L180.07 520.429C179.76 520.979 179.32 521.279 178.77 521.309C178.21 521.349 177.57 521.159 176.85 520.739C176.05 520.279 175.339 519.659 174.729 518.879C174.109 518.099 173.62 517.229 173.27 516.259C172.92 515.289 172.739 514.289 172.749 513.269C172.759 512.249 172.929 511.459 173.289 510.889C173.639 510.319 174.129 510.019 174.759 509.969C175.379 509.919 176.089 510.119 176.889 510.579C177.619 510.999 178.259 511.539 178.809 512.229C179.359 512.909 179.79 513.699 180.1 514.609L182.469 515.979C182.029 514.399 181.299 512.949 180.309 511.659C179.319 510.359 178.169 509.339 176.899 508.599",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.88 527.76C188.08 527.3 187.43 526.6 186.9 525.65C186.38 524.71 186.12 523.65 186.12 522.47C186.12 521.67 186.25 521.07 186.5 520.67C186.76 520.27 187.1 520.05 187.53 520.02C187.96 519.99 188.44 520.13 188.94 520.42C189.44 520.71 189.92 521.13 190.36 521.66C190.8 522.19 191.15 522.81 191.42 523.52C191.68 524.22 191.81 524.97 191.81 525.77C191.81 526.57 191.67 527.16 191.39 527.56C191.11 527.96 190.75 528.17 190.31 528.19C189.86 528.21 189.39 528.08 188.88 527.78M189 518.46C188.09 517.93 187.26 517.69 186.52 517.73C185.78 517.77 185.2 518.1 184.77 518.71C184.34 519.32 184.12 520.19 184.12 521.3C184.12 522.41 184.32 523.53 184.74 524.63C185.15 525.72 185.72 526.72 186.45 527.61C187.18 528.5 187.99 529.2 188.89 529.72C189.8 530.25 190.63 530.49 191.39 530.46C192.14 530.43 192.74 530.1 193.18 529.49C193.62 528.89 193.84 528.02 193.85 526.91C193.86 525.8 193.65 524.68 193.22 523.58C192.79 522.47 192.22 521.47 191.48 520.58C190.74 519.69 189.92 518.98 189.01 518.46",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.619 525.169C200.059 524.849 199.519 524.659 199.019 524.629C198.509 524.589 198.109 524.699 197.779 524.959V523.709L195.809 522.569L195.779 533.519L197.749 534.659L197.769 528.529C197.769 527.549 197.989 526.919 198.429 526.649C198.859 526.379 199.449 526.449 200.189 526.879C200.929 527.309 201.499 527.899 201.929 528.669C202.359 529.449 202.569 530.319 202.569 531.299L202.549 537.429L204.499 538.559L204.519 532.099C204.519 531.099 204.349 530.159 204.019 529.259C203.689 528.359 203.229 527.569 202.629 526.859C202.039 526.169 201.369 525.589 200.609 525.159",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.85 531.65C211.28 531.32 210.75 531.14 210.25 531.11C209.75 531.07 209.34 531.18 209.01 531.44V530.19L207.05 529.05L207.02 540L208.99 541.14L209.01 535.01C209.01 534.03 209.23 533.4 209.67 533.13C210.11 532.86 210.69 532.93 211.43 533.36C212.17 533.79 212.75 534.39 213.18 535.16C213.6 535.93 213.81 536.81 213.81 537.79L213.79 543.92L215.74 545.05L215.76 538.59C215.76 537.59 215.6 536.65 215.27 535.76C214.93 534.86 214.47 534.06 213.88 533.36C213.29 532.67 212.62 532.09 211.87 531.66",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.65 540.84C219.75 540.04 220.04 539.54 220.52 539.32C221.01 539.1 221.59 539.19 222.27 539.58C223.02 540.01 223.64 540.63 224.15 541.42C224.65 542.22 224.91 543.04 224.92 543.88L219.64 540.83M222.36 537.73C221.43 537.19 220.6 536.95 219.87 536.99C219.14 537.03 218.59 537.38 218.19 538.01C217.79 538.63 217.58 539.5 217.58 540.63C217.58 541.76 217.78 542.86 218.18 543.96C218.59 545.05 219.15 546.04 219.87 546.93C220.59 547.82 221.4 548.52 222.31 549.05C223.43 549.7 224.37 549.91 225.12 549.7C225.88 549.5 226.4 548.97 226.7 548.13L224.57 546.9C224.13 547.67 223.38 547.75 222.32 547.14C221.59 546.72 220.96 546.09 220.45 545.26C219.95 544.44 219.67 543.57 219.61 542.67L226.89 546.87C226.94 546.57 226.96 546.21 226.96 545.8C226.96 544.74 226.77 543.69 226.38 542.65C225.99 541.61 225.45 540.66 224.74 539.8C224.04 538.95 223.24 538.26 222.33 537.74",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.95 543.84C232.04 543.32 231.23 543.08 230.53 543.14C229.83 543.2 229.27 543.54 228.87 544.17C228.47 544.79 228.27 545.67 228.27 546.8C228.27 547.93 228.46 549.03 228.86 550.11C229.25 551.19 229.81 552.18 230.51 553.05C231.21 553.93 232.02 554.63 232.93 555.15C234.06 555.8 235.01 556.02 235.77 555.81C236.53 555.59 237.05 555.01 237.33 554.05L235.2 552.82C234.83 553.76 234.07 553.9 232.93 553.24C232.13 552.78 231.48 552.07 231 551.13C230.52 550.19 230.29 549.14 230.29 547.96C230.29 546.78 230.53 546 231.01 545.61C231.49 545.23 232.14 545.28 232.94 545.74C233.52 546.08 234 546.51 234.38 547.03C234.76 547.55 235.04 548.14 235.21 548.78L237.34 550.01C237.08 548.69 236.57 547.5 235.82 546.44C235.06 545.37 234.11 544.51 232.96 543.84",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.63 546.299L239.64 545.149V547.879L238.51 547.229V549.079L239.63 549.729L239.61 555.789C239.61 556.859 239.84 557.779 240.31 558.519C240.78 559.269 241.46 559.909 242.35 560.419L243.91 561.319V559.429L242.7 558.729C242.3 558.499 242.01 558.239 241.85 557.969C241.68 557.689 241.6 557.349 241.6 556.939L241.62 550.879L243.94 552.219V550.369L241.63 549.029V546.299Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.24 456.26C107.85 456.04 107.53 456.22 107.53 456.67L107.43 490.67C107.43 491.12 107.75 491.67 108.14 491.89C108.53 492.11 108.85 491.93 108.85 491.48L108.95 457.48C108.95 457.03 108.64 456.49 108.24 456.26Z",
    fill: "#459AA4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRubixConnect);
export default __webpack_public_path__ + "static/media/RubixConnect.f3d3b827374a824d82ed81d5b9ea8726.svg";
export { ForwardRef as ReactComponent };